// extracted by mini-css-extract-plugin
module.exports = {"popup":"index_popup_17BCw","popup-sm":"index_popup-sm_IN7Yl","btn-close":"index_btn-close_2RBmj","popup-lg":"index_popup-lg_38H2v"};